import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import TableContent from "../../table/table";
import axios from "axios";
import fileDownload from "js-file-download";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteAjendaAction,
  GetAllAjendaAction,
} from "../../../../redux/actions/AjendaAction";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
const Display = ({
  setKey,
  Filee,
  setFilee,
  FileeBase64,
  setBase64,
  Datee,
  setDatee,
  Dategalasa,
  setDategalasa,
  Namemowakell,
  setNamemowakell,
  Sefamo,
  setSefamo,
  NameKhesm,
  setNameKhesm,
  SefaKhesm,
  setSefaKhesm,
  TypeDawa,
  setTypeDawa,
  NumberDawa,
  setNumberDawa,
  Year,
  setYear,
  Mawdodawa,
  setMawdodawa,
  TakadyDegree,
  setTakadyDegree,
  Mahkamaa,
  setMahkama,
  Numbercircle,
  setNumbercircle,
  Typecircle,
  setTypecircle,
  SummaryDawa,
  setSummaryDawa,
  Nots,
  setNots,
  NotsImg,
  setNotsImg,
  Qarar,
  setQarar,
  selectedFile,
  setSelectedFile,
  setIsEdit,
  isEdit,
  setEye,
  Eye,
  setAjendaID,
  AjendaID,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [Searchkey, setSearchkey] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const [showDelete, setshowDelete] = useState(false);
  const PageSize = 7;
  const reportTemplateRef = useRef("");
  const AllAjenda = useSelector((state) => state.AjendaR.getAjenda);
  const dispatch = useDispatch();
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAjendaID(itemid);
  };
  const onPress = async (page) => {
    await dispatch(
      GetAllAjendaAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  useEffect(() => {
    dispatch(
      GetAllAjendaAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  }, [Searchkey, Dateeto, Dateefrom]);
  const handleSubmit = async () => {
    await dispatch(
      GetAllAjendaAction(
        `ToDate=${Dateeto}&FromDate=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  };
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAjendaAction(AjendaID));
    setshowDelete(false);
    setAjendaID("");
    setDatee("");
    setNamemowakell("");
    setSefamo("");
    setNameKhesm("");
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setFilee("");
    setQarar("");
    setDategalasa("");
    setNotsImg("");
    setIsEdit(false);
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const Update = async (item) => {
    setKey("enter");
    setAjendaID(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientNames);
    setSefamo(item.ClientType);
    setMahkama(item.CourtName);
    setDategalasa(item.DateOfNextSession);
    setQarar(item.Decision || "");
    setNameKhesm(item.DefendantNames);
    setSefaKhesm(item.DefendantType);
    setTypeDawa(item.LawSuitForm);
    setNumberDawa(item.LawSuitNumber);
    setNumbercircle(item.LocationNumberName);
    setNots(item.Description || "");
    setTypecircle(item.LocationTypeName);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = async (item) => {
    setKey("enter");
    setAjendaID(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientNames);
    setSefamo(item.ClientType);
    setMahkama(item.CourtName);
    setDategalasa(item.DateOfNextSession);
    setQarar(item.Decision || "");
    setNameKhesm(item.DefendantNames);
    setSefaKhesm(item.DefendantType);
    setTypeDawa(item.LawSuitForm);
    setNumberDawa(item.LawSuitNumber);
    setNumbercircle(item.LocationNumberName);
    setNots(item.Description || "");
    setTypecircle(item.LocationTypeName);
    setIsEdit(false);
    setEye(true);
  };
  const Del = useSelector((state) => state.AjendaR.deleteAjenda);

  useEffect(() => {
    if (Loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (Del) {
        if (Del.StatusCode === 200 || Del.StatusCode === 201) {
          if (
            Del &&
            Del.ResponseMessage === "Great, Lawyer Book deleted Successfully"
          ) {
            dispatch(GetAllAjendaAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (Del.StatusCode !== 200 || Del.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [Loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <div ref={reportTemplateRef}>
          <Table
            id="my-table"
            className="maint"
            responsive
            striped
            bordered
            hover>
            <thead>
              <tr>
                <th>
                  التاريخ<i className="fa-solid fa-hashtag"></i>
                </th>

                <th>
                  الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  صفة الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  نوع الدعوى<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th style={{width: "230px"}}> 
                  القرار <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  تاريخ الجلسة اللاحقة<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  ارشيف المستندات{" "}
                  <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
              </tr>
            </thead>
            <tbody>
              {AllAjenda && AllAjenda.Data && AllAjenda.Data.length > 0
                ? AllAjenda.Data.map((item, idx) => (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                      <td>{item.ClientNames}</td>
                      <td>{item.ClientType}</td>
                      <td>{item.LawSuitForm}</td>
                      <td style={{width: "230px",display:"block"}} >{item.Decision}</td>
                      <td>
                        {item.DateOfNextSession !== null
                          ? new Date(item.DateOfNextSession).toLocaleDateString(
                              "en-GB"
                            )
                          : ""}
                      </td>

                      <td>
                        {" "}
                        {item.FileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.FileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.FileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.Id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => HandleEye(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </Table>
          <Pagination
            onPress={onPress}
            PageSize={PageSize}
            PageCount={AllAjenda ? AllAjenda.TotalPages : null}
            // ForceCount={ForceCount}
            // itemsPerPage={2}
            // items={FilesDetails.data}
          />
        </div>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <ToastContainer autoClose={1200} />
    </>
  );
};
export default Display;
